export class MedicineFilterSettings {
  public name: string;
  public title: string;
  public number: string;
  public alphaIndex: string;
  public activeIngredientId: number;
}